import { render, staticRenderFns } from "./SizePrice.vue?vue&type=template&id=7dd5ad37&scoped=true&"
import script from "./SizePrice.vue?vue&type=script&lang=js&"
export * from "./SizePrice.vue?vue&type=script&lang=js&"
import style0 from "./SizePrice.vue?vue&type=style&index=0&id=7dd5ad37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd5ad37",
  null
  
)

export default component.exports